import React from "react";
import { Row, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { formattedDate } from "../../helpers/Helper";
import TableNoDataIndication from "../common/TableNoDataIndication";
import { useNavigate } from "react-router-dom";
import { BookingStatusWithID } from "../../constants/bookingStatus"
const { SearchBar } = Search;

const BookingList = ({ bookings, loading, setSelectedRow, setModal, setIsAddMode, deleteDoctorById, getAllCenters, handleChangeStatus }) => {
    const navigate = useNavigate();
    console.log('bookings', bookings)
    const tblColumn = [
        {
            dataField: '',
            text: 'Sr.No.',
            formatter: (value, row, index) => {
                return (<>{index + 1}</>)
            }
        }, {
            dataField: "xray_booking_id",
            text: "Booking Id",
            sort: true,
            formatter: (value, row) => {
                return (
                    <span
                        onClick={() => navigate(`/view-booking-detail/${row._id}`)}
                        style={{ cursor: 'pointer' }}
                    >
                        {row.xray_booking_id}
                    </span>
                );
            }
        },
        {
            dataField: "patent_name",
            text: "Patient Name",
            sort: true,
            // filter: textFilter()
        },
        {
            dataField: "patent_gender",
            text: "Gender",
            sort: false,
        },
        {
            dataField: "user",
            text: "User",
            sort: true,
            formatter: (value, row) => {
                return (
                    <span
                        onClick={() => navigate(`/user-info/${row.user_id._id}`)}
                        style={{ cursor: 'pointer' }}
                    >
                        {row.user_id.name || 'N/A'}
                    </span>
                );
            }
        },

        {
            dataField: "xray_type_name",
            text: "X-ray Type",
            sort: false,
        },


        //   {
        //     dataField: "booking_date",
        //     text: "Booking Date",
        //     sort: false,
        //     formatter: (value, row) => {
        //       return <span>{formattedDate(row.booking_date)}</span>;
        //     },

        //   },
        //   {
        //     dataField: "appointment_date",
        //     text: "Appointment Date",
        //     sort: true,
        //     formatter: (value, row) => {
        //       return <span>{formattedDate(row.appointment_date)}</span>;
        //     },
        //   }, {
        //     dataField: 'appointment_slot',
        //     text: 'Appointment Slot',
        //     sort: true
        // },
        , {
            dataField: '',
            text: 'Assign Radiologist',
            formatter: (value, row) => {
                if (row.booking_status_id === BookingStatusWithID.XRAY_UPLOADED && row.inves_report_opted === true) {
                    return (
                        <button className="btn btn-primary"
                            onClick={() => {
                                setSelectedRow(row);
                                setIsAddMode('Edit');
                                setModal(true)
                            }}>
                            <i className="bx bx plus" />Assign

                        </button>
                    );
                }
                return null;
            }
        }
    ];


    const defaultSorted = [{
        dataField: '_id',
        order: "desc",
    }];
    const pzipcodeOptions = {
        sizePerPzipcode: 10,
        totalSize: bookings.length, // replace later with size(customers),
        custom: true
    };
    return (

        <React.Fragment>
            <PaginationProvider
                pagination={paginationFactory(pzipcodeOptions)}
                keyField='id'
                columns={tblColumn}
                data={bookings}
            >
                {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                        keyField='_id'
                        columns={tblColumn}
                        data={bookings}
                        search
                    >
                        {toolkitProps => (
                            <React.Fragment>
                                <Row className="mb-2" style={{ display: 'none' }}>
                                    <Col md="4">
                                        <div className="search-box me-2 mb-2 d-inline-block">
                                            <div className="status-relative">
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xl="12">
                                        <div className="text-right col-md-2 offset-md-10 mb-2">
                                            <label className="pe-3">Search</label>
                                            <SearchBar className="w-100" {...toolkitProps.searchProps} />
                                        </div>
                                        <div className="table-responsive">
                                            <BootstrapTable
                                                noDataIndication={<TableNoDataIndication loading={loading} />}
                                                keyField={"id"}
                                                responsive
                                                bordered={false}
                                                striped={false}
                                                defaultSorted={defaultSorted}
                                                classes={
                                                    "table table-striped align-middle table-nowrap"
                                                }
                                                headerWrapperClasses={"thead-light"}
                                                {...toolkitProps.baseProps}
                                                {...paginationTableProps}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                {bookings.length > 0 &&
                                    <Row className="align-items-md-center mt-30">
                                        <Col className="inner-custom-pagination mt-2 d-flex">
                                            <div className="d-inline">
                                                <SizePerPageDropdownStandalone
                                                    {...paginationProps}
                                                />
                                            </div>
                                            <div className="text-md-right ms-auto">
                                                <PaginationListStandalone
                                                    {...paginationProps}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </React.Fragment>
                        )
                        }
                    </ToolkitProvider>
                )
                }</PaginationProvider>
        </React.Fragment>

    )
}

export default BookingList;
